<template>
  <q-page class="row content-start q-pa-lg">
    <div class="col-12">
      <q-tabs v-model="tab" class="custom-tabs">
        <q-tab
          name="data"
          label="Data"
          class="q-mr-xl text-accent custom-tab"
          :class="{
            'bg-accent text-white': tab == 'data',
            'bg-grey-4 grey-border': tab != 'data',
          }"
        ></q-tab>
        <q-tab
          name="goals"
          label="Goals"
          class="q-mr-xl text-accent custom-tab"
          :class="{
            'bg-accent text-white': tab == 'goals',
            'bg-grey-4 grey-border': tab != 'goals',
          }"
        ></q-tab>
        <q-tab
          name="solutions"
          label="Solutions"
          class="q-mr-xl text-accent custom-tab"
          :class="{
            'bg-accent text-white': tab == 'solutions',
            'bg-grey-4 grey-border': tab != 'solutions',
          }"
        ></q-tab>
        <q-tab
          name="actions"
          label="Actions"
          class="q-mr-xl text-accent custom-tab"
          :class="{
            'bg-accent text-white': tab == 'actions',
            'bg-grey-4 grey-border': tab != 'actions',
          }"
        ></q-tab>
      </q-tabs>
    </div>
    <div class="col-12">
      <q-card class="shadow-4">
        <q-tab-panels
          v-model="tab"
          animated
          transition-prev="slide-right"
          transition-next="slide-left"
        >
          <q-tab-panel name="data">
            <div class="custom-table-container">
              <datatable
                class="custom-table"
                :flat="true"
                :data="[]"
                :columns="dataColumns"
                @rowDoubleClick="handleDoubleClick"
              >
              </datatable>
            </div>
          </q-tab-panel>
          <q-tab-panel name="goals">
            <div class="custom-table-container">
              <datatable
                class="custom-table"
                :flat="true"
                :data="goals"
                :columns="goalColumns"
                @rowDoubleClick="handleDoubleClick"
              >
              </datatable>
            </div>
          </q-tab-panel>
          <q-tab-panel name="solutions">
            <div class="custom-table-container">
              <datatable
                class="custom-table"
                :flat="true"
                :data="solutions"
                :columns="solutionColumns"
                @rowDoubleClick="handleDoubleClick"
              >
                <template slot="body-cell-goal" slot-scope="data">
                  <q-td :props="data.props">
                    {{
                      goals.filter((obj) => {
                        return obj.id == data.props.row.goal_id;
                      })[0].goal
                    }}
                  </q-td>
                </template>
                <template slot="body-cell-kpi" slot-scope="data">
                  <q-td :props="data.props">
                    {{
                      goals.filter((obj) => {
                        return obj.id == data.props.row.goal_id;
                      })[0].goal
                    }}
                  </q-td>
                </template>
              </datatable>
            </div>
          </q-tab-panel>
          <q-tab-panel name="actions">
            <div class="custom-table-container">
              <datatable
                class="custom-table"
                :flat="true"
                :data="actions"
                :columns="actionColumns"
                @rowDoubleClick="handleDoubleClick"
              >
              </datatable>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card>
    </div>
  </q-page>
</template>

<script>
  import { mapGetters } from "vuex";
  import datatable from "@/components/datatable/datatable.vue";

  // import { Notify } from "quasar";

  export default {
    components: { datatable },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        goals: "goals/list",
        goalsLoading: "goals/listLoading",
        solutions: "solutions/list",
        solutionsLoading: "solutions/listLoading",
        actions: "actions/list",
        actionsLoading: "actions/listLoading",
      }),
    },
    data: () => ({
      dataColumns: [
        {
          name: "source",
          label: "Source",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white",
        },
        {
          name: "type",
          label: "Type",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white",
        },
        {
          name: "qty",
          label: "QTY",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white",
        },
        {
          name: "unit",
          label: "Unit",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white",
        },
        {
          name: "Reference Notes",
          label: "Name",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white",
        },
        {
          name: "editEntry",
          label: "",
          align: "left",
          // field: "goal",
          headerClasses: "bg-primary text-white",
        },
      ],
      goalColumns: [
        {
          name: "goal",
          label: "Goals",
          align: "left",
          field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "kpi",
          label: "KPI",
          align: "left",
          field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "time_frame",
          label: "TimeFrame",
          align: "left",
          // field: "status",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "total_summary",
          label: "Total Summary",
          align: "left",
          // field: "created_by",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "editEntry",
          label: "",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
      ],
      solutionColumns: [
        {
          name: "goal",
          label: "Goal",
          align: "left",
          field: "goal_id",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "kpi",
          label: "KPI",
          align: "left",
          field: "goal_id",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "solution",
          label: "Solution",
          align: "left",
          field: "shortDesc",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "editEntry",
          label: "",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
      ],
      actionColumns: [
        {
          name: "goal",
          label: "Goal",
          align: "left",
          field: "title",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "kpi",
          label: "KPI",
          align: "left",
          field: "title",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "solution_1",
          label: "Solution 1",
          align: "left",
          // field: "status",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "solution_2",
          label: "Solution 2",
          align: "left",
          // field: "created_by",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "solution_3",
          label: "Solution 3",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
        {
          name: "editEntry",
          label: "",
          align: "left",
          // field: "goal",
          sortable: true,
          headerClasses: "bg-primary text-white text-center",
        },
      ],
      tab: "data",

      createLoading: false,

      newDialog: false,

      // View and Edit
      viewFormData: {},
      saveLoading: false,
      viewDetailsDialog: false,
    }),
    beforeCreate() {
      // this.$store.dispatch("outcomes/loadAll");
      this.$store.dispatch("goals/loadAll");
    },
    mounted() {},
    methods: {
      handleDoubleClick(row) {
        // this.viewFormData = row;
        // this.viewDetailsDialog = true;
        this.$router.push("/actioncentre/" + row.id);
      },
      test() {
        console.log("HERE");
      },
    },
  };
</script>

<style scoped>
  #depthCard:hover {
    background: #5cb3ff;
    color: white;
  }
</style>

<style lang="scss">
  .custom-tabs {
    border-bottom: 4px solid $accent;

    .q-tabs__content {
      justify-content: flex-start;
    }

    .custom-tab {
      min-width: 210px;
      border-radius: 10px 10px 0 0;

      .q-tab__indicator {
        height: 0 !important;
      }
    }

    .grey-border {
      border: 2px solid #dcdcdc;
      border-bottom: 0;
    }
  }

  .custom-table-container {
    border: 1px solid #162c47;
    border-radius: 10px;

    .custom-table {
      height: calc(100vw - 1182px) !important;
      .q-table__container {
        border-radius: 10px;
      }
    }
  }
</style>
